<template>
  <div class="section-container">
    <slot />
    <div v-if="showEdit && !hideEdit" class="mt-auto">
      <div class="section-action-divider">
        <a href="#" @click.prevent="handleEditClick" class="">{{ t('section.edit') }}</a>
      </div>
    </div>
    <div v-if="showAdd" class="mt-auto">
      <div class="pt-[2x] pb-[11px]">
        <a href="#" @click.prevent="handleEditClick" class="">{{ t('section.add') }}</a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['edit']);
const { t } = useI18n();
const props = defineProps({
  showEdit: {
    type: Boolean,
    default: true,
  },
  hideEdit: {
    type: Boolean,
    default: false,
  },
  showAdd: {
    type: Boolean,
    default: false,
  },
});

const handleEditClick = () => {
  emit('edit');
};
</script>

<style scoped>
.mt-auto {
  margin-top: auto; /* Push the Edit link to the bottom */
}
</style>
